"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSuiteProfilesService = exports.authSuiteProfilesService = void 0;
var tslib_1 = require("tslib");
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var models_1 = require("../models");
var isDefined_1 = require("../../utils/isDefined");
var get_profile_guard_1 = require("./response-guards/get-profile-guard");
var profilesBaseRoute = "profiles";
var createProfile = function (request) {
    var createProfileRoute = profilesBaseRoute;
    var payload = tslib_1.__assign({}, request);
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: createProfileRoute,
    });
};
var getProfile = function (request) {
    var getProfileRoute = "".concat(profilesBaseRoute, "/").concat(request.profileId);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: getProfileRoute,
        responseGuard: (0, get_profile_guard_1.getProfileGuard)(getProfileRoute, request.profileId),
    });
};
var getProfiles = function (brandKidsFilterOn) {
    if (brandKidsFilterOn === void 0) { brandKidsFilterOn = true; }
    var getProfilesRoute = profilesBaseRoute;
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.get({
        path: getProfilesRoute,
        requestParams: [models_1.AuthSuiteSdkClientRequestParams.BrandKidsFilterOn],
        request: { brandKidsFilterOn: brandKidsFilterOn },
    });
};
var selectProfile = function (request) {
    var selectProfileRoute = "".concat(profilesBaseRoute, "/").concat(request.profileId, "/select");
    var effectiveBrandKidsFilterOn = (0, isDefined_1.isDefined)(request.brandKidsFilterOn) ? request.brandKidsFilterOn : true;
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        path: selectProfileRoute,
        requestParams: [models_1.AuthSuiteSdkClientRequestParams.BrandKidsFilterOn],
        request: { brandKidsFilterOn: effectiveBrandKidsFilterOn },
    });
};
var deleteProfile = function (request) {
    var deleteProfileRoute = "".concat(profilesBaseRoute, "/").concat(request.profileId);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.delete({
        path: deleteProfileRoute,
    });
};
var updateProfile = function (request) {
    var updateProfileRoute = "".concat(profilesBaseRoute, "/").concat(request.profileId);
    var payload = {
        profile: request.profile,
    };
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.patch({
        body: body,
        path: updateProfileRoute,
    });
};
exports.authSuiteProfilesService = {
    createProfile: createProfile,
    getProfile: getProfile,
    getProfiles: getProfiles,
    selectProfile: selectProfile,
    deleteProfile: deleteProfile,
    updateProfile: updateProfile,
};
var AuthSuiteProfilesService = /** @class */ (function () {
    function AuthSuiteProfilesService() {
        return exports.authSuiteProfilesService;
    }
    return AuthSuiteProfilesService;
}());
exports.AuthSuiteProfilesService = AuthSuiteProfilesService;
